module.exports = __webpack_public_path__ + "static/media/ampelregelung.f99cf5e8.svg";